import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { TitleService } from '../../../../core/services/title.service';
import { SignInFormComponent } from '../../components/sign-in-form/sign-in-form.component';

@Component({
	selector: 'app-sign-in-page',
	imports: [SignInFormComponent, NgOptimizedImage],
	templateUrl: './sign-in-page.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignInPageComponent implements OnInit {
	private readonly titleService = inject(TitleService);

	ngOnInit(): void {
		this.titleService.setTitle('Sign In');
	}
}
